import { OrderV2, ORDER_SIDE, ORDER_STATUS, ORDER_TYPE } from "@cede/types";
import { randomNumberId } from "../random";
import Decimal from "decimal.js";

export class SdkOrderV2Factory {
  private orders: OrderV2[] = [];

  createAndGet(data: Partial<OrderV2> = {}): OrderV2 {
    const order: OrderV2 = {
      id: String(randomNumberId()),
      timestamp: 0,
      status: ORDER_STATUS.OPEN,
      pairSymbol: "",
      type: ORDER_TYPE.MARKET,
      side: ORDER_SIDE.BUY,
      price: new Decimal(0),
      amount: new Decimal(0),
      filled: new Decimal(0),
      fee: {
        amount: new Decimal(0),
        refAmount: undefined,
        tokenSymbol: "",
      },
      ...data,
    };
    this.orders.push(order);
    return order;
  }

  create(data: Partial<OrderV2>) {
    this.createAndGet(data);
    return this;
  }

  getAll(): OrderV2[] {
    return this.orders;
  }
}
